export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "SBI Car Loan EMI Calculator: Drive Your Dream Car with Smart Planning ",
    subHeading:
      "The SBI Car Loan EMI Calculator helps you estimate your monthly EMI, total repayment, and interest costs—ensuring hassle-free financial planning before you purchase your car. Whether you’re looking for a fuel-efficient hatchback, a premium SUV, or an electric vehicle (EV), knowing your EMI beforehand allows you to budget wisely.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
